import React, { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import { statusCodeReportGenerated } from "../../utils/Strings";
import { fontMedium } from "../../utils/AppStyle";
import { isNullOrEmpty, isObject } from "../../utils/AppUtil";
import { checkFipStatus, updateAAEvent } from "../../utils/NetworkUtil";
import { aaEventFilter, getAARedirection, getProcessingDesc, getProcessingTitle } from "../../Config";
import { databaseRef } from '../../utils/firebase';
import { Loader } from "../../utils/Loader";
import { getLoaderStyle } from "../../Config";
import { child, onValue } from "firebase/database";

const AACallbackComponent = ({ setShowCancel }) => {

  let history = useHistory();
  const iframeRef = useRef(null);
  const location = useLocation();

  const [isIframe, setIsIframe] = useState(location?.state?.iframeLoading ?? false);
  const [isIframeProcessing, setIsIframeProcessing] = useState(isIframe);
  const [redirectUrl, setRedirectUrl] = useState(location?.state?.aaUrl ?? "");
  const [terminalEvents, setTerminalEvents] = useState(location?.state?.terminalEvents ?? []);


  useEffect(() => {
    setShowCancel("false");
    let url_string = window.location.href;
    url_string = url_string.replace('#', '?');
    let url = new URL(url_string);
    let params = url.searchParams;
    if (!isNullOrEmpty(params)) {
      sendDataToBackend(params);
    }
    else {
      if (!isIframe && !isIframeProcessing) {
        handleNextScreen();
      }
    }

    const handleMessageEvent = (e) => {
      console.log("event data");
      console.log(e.data);
      if (!isNullOrEmpty(e.data)) {

        let event = "";

        if (isObject(e.data)) {
          if ('message' in e.data) {
            event = e.data['message']?.eventCode;
          }
        }
        else {
          event = e.data;
        }

        //if(!isNullOrEmpty(event) && (listOfAAEvents.includes(event) || (listOfApiFailEvents.some((str) => str.startsWith(searchString))))) {
        if(!isNullOrEmpty(event) && (!aaEventFilter.some((prefix) => event.startsWith(prefix)))) {
          updateAAEvent(event, (response) => {
            if (terminalEvents?.includes(event)) {
              aaFlowEnd();
            }
          });
        }
      }
    };

    // Add event listener for messages
    window.addEventListener("message", handleMessageEvent);

    return () => {
      window.removeEventListener("message", handleMessageEvent);
    };


  }, []);

  const checkStatusCodeAndRedirect = () => {
    let txnId = sessionStorage.getItem("txn_id");
    const txnRef = child(databaseRef, txnId);
    const txnDataRef = child(txnRef, "txn_data");

    onValue(txnDataRef, function (snapshot) {
      let datas = JSON.stringify(snapshot);
      var txnData = JSON.parse(datas);

      if (txnData.txn_status.code === statusCodeReportGenerated) { // updating isprocessing value based on the status code
        //setIsProcessing("0")
        sessionStorage.setItem('status', true);
        sessionStorage.setItem('is_processing', '0');
      }
      else {
        sessionStorage.setItem('status', 'in-progress');
        sessionStorage.setItem('is_processing', '1');
      }
      sessionStorage.setItem('token_valid', false);
      history.push("/txncomplete");
      //redirectToClient();
    });
  }

  const sendDataToBackend = (params) => {
    let ecres = params.get("ecres", "");
    let resdate = params.get("resdate", "");
    let fi = params.get("fi", "");
    const aaCb = (res) => {
      handleNextScreen();
    }

    checkFipStatus(ecres, resdate, fi, history, aaCb);
  }

  /* Redirecting to next screen based on return url and shw_rpt variable */
  const handleNextScreen = () => {
    if ((getAARedirection() == "true") || ((!isNullOrEmpty(sessionStorage.getItem('user_redirection'))) && (sessionStorage.getItem('user_redirection') == '1'))) { // Added themeId check
      checkStatusCodeAndRedirect()   // Checking ReportGenerated Status Code and redirecting immediately to return url
    }
    else {
      history.push("/process");
    }
  }

  const aaFlowEnd = () => {
    setIsIframeProcessing(false);
    handleNextScreen();
  }

  return (
    <div>
      <div className="normal-card">

        {
          (isIframe && isIframeProcessing) ?
            <iframe
              ref={iframeRef}
              src={redirectUrl}
              style={{ width: '100%', height: '750px', border: 'none' }}
              title="AA Iframe"
            /> : <>
              <Loader loaderStyle={getLoaderStyle()} />
              <br /><br />
              <div className="card-title" style={fontMedium}>{getProcessingTitle()}</div><br />
              <div className="card-msg" style={fontMedium}>
                {getProcessingDesc()}
              </div>
            </>
        }
      </div>
    </div>
  );
};

export default withRouter(AACallbackComponent);